import { FunctionComponent, useCallback, useContext } from 'react'
import SocialButton from './Button'
import EndOfArticleContext from '@contexts/endOfArticle'
import { stripHtml } from '@hooks/useTracking/utils'
import useTracking, { TrackingFnType } from '@hooks/useTracking'

const Print: FunctionComponent = () => {
  const endOfArticle = useContext(EndOfArticleContext)
  const trackingOnClick = useCallback<TrackingFnType>(
    ({ pageMetadata }) => {
      return {
        event: 'article_share',
        eventCategory: 'article',
        eventAction: `share_print_${endOfArticle ? 'bottom' : 'top'}`,
        eventLabel: `${pageMetadata.id}:${stripHtml(pageMetadata.title)}`,
        nonInteraction: false,
      }
    },
    [endOfArticle]
  )
  const trackingFunction = useTracking(trackingOnClick)
  const handlePrint = useCallback(() => {
    trackingFunction()
    print()
  }, [trackingFunction])
  return <SocialButton onClick={handlePrint} type="print" />
}

export default Print
